import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {populateFormFields} from '../common/formPanel.js';
import {ImportUtil} from '../../utils/importUtil.js';


/* global customElements */
class ImportOptionForm extends BaseComponent {
	
	static get properties() {
		return {			
			showGPSFilter: Boolean,
			visibleOptions: {type: Array},
			dataTypes: String,
			savedOptions: {type: Object}
		};
	}
	
	constructor() {
		super();
				
		var importOptionForm = this;
		
		importOptionForm.showGPSFilter = false;
		importOptionForm.visibleOptions = null;
		importOptionForm.dataTypes = null;
		importOptionForm.savedOptions = null;
		
		setTimeout(function(){
			importOptionForm.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}

	isOptionVisible(optionName) {
		var importOptionForm = this;
		if (!importOptionForm.visibleOptions || importOptionForm.visibleOptions.length === 0) {
			var defaults = [
				'filterStartDate',
				'filterEndDate',
				'inputTimeZone',
				'datafilterId',
				'unitMatchId',
				'autoUnitId',
				'autoGroupId',
				'dataTransformRuleSetId'
			];
			if (importOptionForm.showGPSFilter) {
				defaults.push('gpsFilteringOff');
				defaults.push('gpsFilterId');
			}
			return defaults.indexOf(optionName) !== -1;
		}
		return importOptionForm.visibleOptions.indexOf(optionName) !== -1;
	}

	optionClass(optionName) {
		return this.isOptionVisible(optionName) ? '' : 'hide';
	}
	
	defaultFilterStartDate() {
		var importOptionForm = this;
		if (!importOptionForm.isOptionVisible('filterStartDate')) {
			return '';
		}
		if (importOptionForm.savedOptions && importOptionForm.savedOptions.filterStartDate) {
			return TimeUtil.formatDateForDateLoad(importOptionForm.savedOptions.filterStartDate);
		}
		return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());
	}

	defaultFilterEndDate() {
		var importOptionForm = this;
		if (!importOptionForm.isOptionVisible('filterEndDate')) {
			return '';
		}
		if (importOptionForm.savedOptions && importOptionForm.savedOptions.filterEndDate) {
			return TimeUtil.formatDateForDateLoad(importOptionForm.savedOptions.filterEndDate);
		}
		return '';
	}

	applySavedOptions() {
		var importOptionForm = this;
		if (!importOptionForm.savedOptions) {
			return;
		}
		var mainLayout = importOptionForm.querySelector('vaadin-form-layout');
		if (!mainLayout) {
			return;
		}
		var loadOptions = { refreshComponents: true };
		populateFormFields(mainLayout, importOptionForm.savedOptions, loadOptions);
		var gpsFilteringOff = mainLayout.querySelector('[name="gpsFilteringOff"]');
		var gpsFilterCombo = ElementUtil.query(mainLayout, 'gpsFilterCB');
		if (gpsFilteringOff && gpsFilterCombo) {
			gpsFilterCombo.disabled = !!gpsFilteringOff.checked;
		}
	}

	init() {
		var importOptionForm = this;
		
		var mainLayout = ElementUtil.create({
			tag: 'vaadin-form-layout',
			children: [
				{
					tag: 'vaadin-date-picker',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					'class': importOptionForm.optionClass('filterStartDate'),
					value: importOptionForm.defaultFilterStartDate()
				},
				{
					tag: 'vaadin-date-picker',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					'class': importOptionForm.optionClass('filterEndDate'),
					value: importOptionForm.defaultFilterEndDate()
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'inputTimeZone',
					label: 'Input Time Zone',
					'class': importOptionForm.optionClass('inputTimeZone'),
					'item-value-path': 'code',
					'item-label-path': 'description',											
					postinit: function (combo) {
						Service.getLookupService().getLookupValues('TimeZone').then(function (data) {																									
							
							//add additional
							for (var i=1; i<13; i++) {
								data.push({
									code: '+' + i,
									description: '+' + i
								});						
							}
							
							for (var i=1; i<13; i++) {
								data.push({
									code: '-' + i,
									description: '-' + i
								});						
							}
							
							combo.items = data;
						});
					},
					placeHolder: 'Select'					
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'datafilterId',
					label: 'Data Filter',
					'class': importOptionForm.optionClass('datafilterId'),
					'item-value-path': 'datafilterId',
					'item-label-path': 'name',
					clearButtonVisible: true,
					postinit: function (combo) {
						DataManagementService.getDataFilteringService().getDataFilters().then(function (data) {
							var filters = data || [];
							if (importOptionForm.dataTypes) {
								var allowedTypes = String(importOptionForm.dataTypes).split(',').map(function (type) {
									return type.trim();
								});
								filters = filters.filter(function (filter) {
									return allowedTypes.indexOf(filter.dataType) !== -1;
								});
							}
							filters.sort(function (a, b) {
								var nameA = (a.name || '').toLowerCase();
								var nameB = (b.name || '').toLowerCase();
								return nameA.localeCompare(nameB);
							});
							combo.items = filters;
						});
					},
					placeHolder: 'Select'					
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'unitMatchId',
					label: 'Unit Matching',
					'class': importOptionForm.optionClass('unitMatchId'),
					'item-value-path': 'unitMatchId',
					'item-label-path': 'name',																
					postinit: function (combo) {
						UnitService.getUnitMatchingService().getUnitMatchingSets().then(function (data) {																									
							combo.items = data;
						});
					},
					placeHolder: 'Select'					
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'autoUnitId',
					label: 'Auto Unit',
					'class': importOptionForm.optionClass('autoUnitId'),
					'item-value-path': 'autoUnitId',
					'item-label-path': 'name',
					clearButtonVisible: true,
					postinit: function (combo) {
						UnitService.getAutoUnitService().getAutoUnitConfigs().then(function (data) {
							var all = [];
							(data || []).forEach(function (item) {
								all.push(item);
							});
							all.push({
								autoUnitId: 'NO_AUTO_UNIT',
								name: 'No Auto Unit Creation'
							});
							combo.items = all;
							if (!importOptionForm.savedOptions) {
								var defaultAutoUnitId = ImportUtil.defaultAutoUnitIdForDataTypes(importOptionForm.dataTypes);
								if (defaultAutoUnitId) {
									combo.value = defaultAutoUnitId;
								}
							}
						});
					},
					placeHolder: ImportUtil.autoUnitPlaceholderForDataTypes(importOptionForm.dataTypes)
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'autoGroupId',
					label: 'Auto Group',
					'class': importOptionForm.optionClass('autoGroupId'),
					'item-value-path': 'autoGroupId',
					'item-label-path': 'name',											
					postinit: function (combo) {
						var dataType = null;
						if (importOptionForm.dataTypes) {
							dataType = String(importOptionForm.dataTypes).split(',')[0].trim();
						}
						UnitService.getAutoGroupService().getAutoGroupConfigs(dataType).then(function (data) {																									
							combo.items = data;
						});
					},
					placeHolder: 'Select'					
				},
				{
					tag: 'vaadin-combo-box',					
					name: 'dataTransformRuleSetId',
					label: 'Data Transform Rule Set',
					'class': importOptionForm.optionClass('dataTransformRuleSetId'),
					'item-value-path': 'dataTransformRuleSetId',
					'item-label-path': 'name',											
					postinit: function (combo) {
						var dataType = null;
						if (importOptionForm.dataTypes) {
							dataType = String(importOptionForm.dataTypes).split(',')[0].trim();
						}
						DataManagementService.getDataTransformRuleSetService().getDataTransformRuleSets(dataType).then(function (data) {																									
							combo.items = data;
						});
					},
					placeHolder: 'Select'					
				},
				{
					tag: 'vaadin-checkbox',
					name: 'gpsFilteringOff',
					label: 'GPS Filtering Off',
					'class': importOptionForm.optionClass('gpsFilteringOff'),
					listeners: {
						change: function(event) {
							var newValue = event.target.checked;
							if (newValue) {
								ElementUtil.query(mainLayout, 'gpsFilterCB').disabled = true;
							} else {
								ElementUtil.query(mainLayout, 'gpsFilterCB').disabled = false;
							}
						}
					}
				},
				{
					tag: 'vaadin-combo-box',	
					itemid: 'gpsFilterCB',
					name: 'gpsFilterId',
					label: 'GPS Filtering',
					'item-value-path': 'gpsFilterId',
					'item-label-path': 'name',
					'class': importOptionForm.optionClass('gpsFilterId'),
					postinit: function (combo) {
						DataManagementService.getGPSFilteringService().getGPSFilters().then(function (data) {																									
							combo.items = data;
						});
					},
					placeHolder: 'Default Filter'					
				}
				
			]
		});
		
		importOptionForm.append(mainLayout);

		if (importOptionForm.savedOptions) {
			importOptionForm.applySavedOptions();
			setTimeout(function() {
				importOptionForm.applySavedOptions();
			}, 400);
		}
	}
	
}
customElements.define('dl-import-option-form', ImportOptionForm);
